// extracted by mini-css-extract-plugin
export default {"title__container":"Base_title__container__F30Yq","root--hidden":"Base_root--hidden__8WZCL","root__container":"Base_root__container__XERnZ","title":"Base_title__g7NVW"};